import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef, Inject, Input, OnDestroy, OnInit, PLATFORM_ID,
  ViewChild
} from '@angular/core';
import { componentDestroyed, LeagueNews, LeagueNewsType, Sport, UntilDestroy } from '@mtgame/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { DIRECTION_HORIZONTAL, Manager, Swipe } from '@squadette/hammerjs';
import { LeagueHomeService } from '@core/services/league-home.service';
import { takeUntil } from 'rxjs/operators';
import { getLeagueNewsDetailRoute } from '@config/routes';
import { isPlatformBrowser } from '@angular/common';

@UntilDestroy
@Component({
  selector: 'mtg-news-slider',
  templateUrl: './news-slider.component.html',
  styleUrls: ['./news-slider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({opacity: 0}),
        animate('200ms ease-in', style({opacity: 1}))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({opacity: 0}))
      ])
    ])
  ]
})
export class NewsSliderComponent implements OnInit, OnDestroy, AfterViewInit {
  slides: LeagueNews[];
  current = 0;
  @ViewChild('slider', {read: ElementRef})
  slider: ElementRef;
  isBrowser = isPlatformBrowser(this.platformId);
  loaded = false;
  newsTypes = LeagueNewsType;

  @Input()
  sport: Sport;

  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    private leagueHomeService: LeagueHomeService,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    this.leagueHomeService.mainNews$
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(slides => {
        this.slides = slides.splice(0, 12);
        this.cdr.markForCheck();
      });
    if (this.isBrowser) {
      setTimeout(() => {
        this.loaded = true;
        this.cdr.markForCheck();
      }, 100);
    }
  }

  ngOnDestroy(): void {
  }

  ngAfterViewInit(): void {
    if (this.isBrowser) {
      const manager = new Manager(this.slider.nativeElement);
      manager.add(new Swipe({direction: DIRECTION_HORIZONTAL, threshold: 0}));
      manager.on('swipeleft', (event) => this.next());
      manager.on('swiperight', (event) => this.prev());
    }
  }

  select(slide: number): void {
    this.current = slide;
  }

  next(): void {
    if (this.current === this.slides.length - 1) {
      this.current = 0;
    } else {
      this.current++;
    }
    this.cdr.markForCheck();
  }

  prev() {
    if (this.current === 0) {
      this.current = this.slides.length - 1;
    } else {
      this.current--;
    }
    this.cdr.markForCheck();
  }

  getNewsRoute(newsId: number): string[] {
    return getLeagueNewsDetailRoute(newsId);
  }
}
